import { render, staticRenderFns } from "./DisableUserModal.vue?vue&type=template&id=eb976f78&scoped=true&"
import script from "./DisableUserModal.vue?vue&type=script&lang=ts&"
export * from "./DisableUserModal.vue?vue&type=script&lang=ts&"
import style0 from "./DisableUserModal.vue?vue&type=style&index=0&id=eb976f78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb976f78",
  null
  
)

export default component.exports